// extracted by mini-css-extract-plugin
export default {"textStyle":"DisplayDataa_textStyle__cyJBN","container":"DisplayDataa_container__lpd38"};